/**
 * @fileoverview AI Test Data Generation API Service
 * @description API client for the multi-agent test data orchestration module
 */

import { apiClient } from '@/services/api/client';

const BASE = '/v1/ai-test-data';

export const aiTestDataApi = {
  /** Get list of available agents */
  getAgents: () => apiClient.get(`${BASE}/agents`),

  /** Get dynamic prompt suggestions based on user's past usage */
  getSuggestions: () => apiClient.get(`${BASE}/suggestions`),

  /** Run the full LangChain ReAct agent — returns all events in one response */
  runAgent: (prompt) => apiClient.post(`${BASE}/run`, { prompt }),

  /** Run the agent with SSE streaming — returns a fetch Response for reading the stream */
  runAgentStream: async (prompt, history = []) => {
    const token = apiClient._getAccessToken ? apiClient._getAccessToken() : null;
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const resp = await fetch(`${apiClient.baseURL || '/api'}${BASE}/run-stream`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ prompt, history }),
    });
    return resp;
  },

  /** Create an execution plan from a natural language prompt */
  createPlan: (prompt) => apiClient.post(`${BASE}/plan`, { prompt }),

  /** Execute a single step from the plan */
  executeStep: (step, context = {}) => apiClient.post(`${BASE}/execute-step`, { step, context }),

  /** Execute all steps sequentially */
  executeAll: (plan) => apiClient.post(`${BASE}/execute-all`, { plan }),

  /** List TDM-generated PNR bookings for the current user */
  listBookings: () => apiClient.get(`${BASE}/bookings`),

  /** Save a PNR booking result */
  saveBooking: (pnrResult, prompt = '') => apiClient.post(`${BASE}/bookings`, { pnr_result: pnrResult, prompt }),

  /** Delete a TDM booking by ID */
  deleteBooking: (bookingId) => apiClient.delete(`${BASE}/bookings/${bookingId}`),
};

export default aiTestDataApi;
